export class ColumnMapper {
    private mapFieldIndex: Map<string, number>;

    constructor(selectedColumns: string[]) {
        this.mapFieldIndex = new Map<string, number>();
        for (let i = 0; i < selectedColumns.length; i++) {
            if (selectedColumns[i]) {
                this.mapFieldIndex.set(selectedColumns[i], i);
            }
        }
    }

    getValue(row: string[], field: string): string | null {
        const index = this.mapFieldIndex.get(field);
        const s = index !== undefined ? row[index] : null;
        // console.log(field, index, s);
        return s;
    }
}
